module.exports = __webpack_public_path__ + "img/logo-yooda-one-big.e017343f.png";